// consent.guard.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomCookieService } from 'src/app/services/custom-cookie.service';

@Injectable({
  providedIn: 'root',
})
export class ConsentGuard implements CanActivate,CanActivateChild {
  constructor(
    private cookieService: CustomCookieService,
    private router: Router
  ) {}
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivateLogic()
    }

  canActivate(): boolean {
   return this.canActivateLogic()
  }


  canActivateLogic():boolean{
  
    
    if (this.cookieService.getConsent()==='false') {
        this.router.navigate(['/cookie-error']);
        return false;
      }
      return true;
  }
}
